// @flow

import React from "react"
import { Switch, Route, Redirect } from "react-router-dom"
import { injectIntl } from "react-intl"
import Welcome from "./Welcome"
import CreateAccount from "./CreateAccount"
import PhoneNumberVerification from "./PhoneNumberVerification"

const DriverWebOnBoarding = () => {
  return (
    <Switch>
      <Route exact path="/driver/welcome/:token" component={Welcome} />
      <Route
        exact
        path="/driver/create-account/:token"
        component={CreateAccount}
      />
      <Route
        exact
        path={"/driver/verify-phone/:token"}
        component={PhoneNumberVerification}
      />
      <Route render={() => <Redirect to="/" />} />
    </Switch>
  )
}

export default (injectIntl(DriverWebOnBoarding): any)
